// extracted by mini-css-extract-plugin
export default {"target_purchase":"g-","btns":"h-","btn":"i-","active":"j-","footer":"k-"};
    if(module.hot) {
      // 1713912567621
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  